import httpClient from '../httpClient';

export async function getPlanoTrabalhoAct(id: string) {
  try {
    const response = await httpClient.get(`/api/act-plano-trabalho/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter registro: ' + error);
  }
}

export async function getAllPlanosTrabalhoAct() {
  try {
    const response = await httpClient.get(`/api/act-plano-trabalho`);
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de registros: ' + error);
  }
}

export async function getPlanosTrabalhoPorAct(id: string) {
  try {
    const response = await httpClient.get(`/api/act-plano-trabalho/act/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter dados da Incorporação no SUS: ' + error);
  }
}
